import React from 'react';
import { DeleteRegularIcon, EditRegularIcon, LinkRegularIcon } from 'src/monet/icons';
import { ContextMenuButton } from './components/context-menu-button';
import { useEditorStore } from './editor-store';
import { Block, Section } from './types';
import { useEditorContext } from 'src/store/editor';
import { useCurrentOrganization } from 'src/store/organization';
import { generateJourneyShareUrl } from 'src/utils/journey';
import { useClipboard } from 'src/utils/use-clipboard.hook';
import { shallow } from 'zustand/shallow';

type Props = {
  previousSectionId: Section['id'];
  nextSectionId: Section['id'];
};

export const SectionDividerContextMenuContent = ({ previousSectionId, nextSectionId }: Props) => {
  const dispatchUserEditorAction = useEditorStore((state) => state.dispatchUserEditorAction);
  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);
  const sections = useEditorStore((state) => state.layout.sections);
  const journey = useEditorContext((state) => state.journey);
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization, shallow);

  const [copyLabel, setCopyLabel] = React.useState('Copy link to section below');

  const { copyToClipboard } = useClipboard({
    onCopy: () => {
      setCopyLabel('Copied');
      setTimeout(() => {
        clearContextMenuState();
      }, 1000);
    }
  });

  const onDeleteSection = () => {
    dispatchUserEditorAction({
      type: 'merge-sections',
      previousSectionId,
      nextSectionId,
    });
    clearContextMenuState();
  };

  const copyAliasToClipboard = () => {
    let stepPath = '';
    const nextSection = sections.find((section: Section) => section.id === nextSectionId);
    if (nextSection) {
      stepPath = nextSection.friendlyPath;
    }

    const shareUrl = generateJourneyShareUrl(currentOrganization, journey, stepPath);
    copyToClipboard(shareUrl);
  };

  return (
    <>
      <ContextMenuButton onClick={onDeleteSection} label='Delete divider'>
        <DeleteRegularIcon className='w-4 h-4' />
      </ContextMenuButton>
      <ContextMenuButton onClick={copyAliasToClipboard} label={copyLabel}>
        <LinkRegularIcon className='w-4 h-4' />
      </ContextMenuButton>
    </>
  );
};
